import { render, staticRenderFns } from "./importPlatDictList.vue?vue&type=template&id=327fe740&scoped=true"
import script from "./importPlatDictList.vue?vue&type=script&lang=js"
export * from "./importPlatDictList.vue?vue&type=script&lang=js"
import style0 from "./importPlatDictList.vue?vue&type=style&index=0&id=327fe740&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327fe740",
  null
  
)

export default component.exports